import React, {Component} from 'react'
import propTypes from 'prop-types'
import {get} from 'lodash'
import Button from '@material-ui/core/Button'
import MuiDialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'

class Prompt extends Component {
  componentDidMount() {
    if (this.props.open) this.init()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) this.init()
    if (prevProps.open && !this.props.open) this.deinit()
  }

  componentWillUnmount() {
    this.deinit()
  }

  init = () => {
    window.addEventListener("keydown", this.keyDown)
  }

  deinit = () => {
    window.removeEventListener("keydown", this.keyDown)
  }

  keyDown = (e) => {
    switch (e.keyCode) {
      case 13:  // ENTER
        this.defaultKeyPress(e)
        break
      case 27:  // ESC
        this.cancelKeyPress(e)
        break
    }
  }

  defaultKeyPress = (e) => {
    const {actions} = this.props
    if (actions) {
      const action = actions.find(action => action.isDefault)
      if (action) action.onAction(e)
    }
  }

  cancelKeyPress = (e) => {
    const {actions} = this.props
    if (actions) {
      const action = actions.find(action => action.isCancel)
      if (action) action.onAction(e)
    }
  }

  render() {
    const {className} = this.props

    const buttonStyle = {margin: 8}

    let actionContainer
    if (this.props.actions) {
      actionContainer = this.props.actions.map((action, index) => {
        const className = get(action, 'className', null)
        return (
          <Button
            key={'promptActionButton' + index}
            className={className}
            disabled={action.disabled}
            onClick={action.onAction}
            style={action.primary ? buttonStyle : {...buttonStyle, color: 'var(--cg-color-text-primary)'}}
            variant={action.primary ? 'contained' : 'text'}
            color={action.primary ? 'primary' : 'default'}
          >
            {action.title}
          </Button>
        )
      })
    }

    const title = this.props.title
    const content = this.props.message || this.props.children

    return (
      <MuiDialog
        className={className}
        open={this.props.open}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        PaperProps={{
          style: {
            minWidth: 400,
          },
        }}
      >
        {title && (
          <DialogTitle>
            {title}
          </DialogTitle>
        )}
        <DialogContent
          style={{overflowY: 'visible'}}
        >
          {content}
        </DialogContent>
        {actionContainer && actionContainer.length > 0 && (
          <DialogActions>
            {actionContainer}
          </DialogActions>
        )}
      </MuiDialog>
    )
  }
}

Prompt.defaultProps = {
  className: null,
  open: false,
  actions: [],
}

Prompt.propTypes = {
  actions: propTypes.arrayOf(
    propTypes.shape({
      disabled: propTypes.bool,
      isCancel: propTypes.bool,
      isDefault: propTypes.bool,
      onAction: propTypes.func.isRequired,
      primary: propTypes.bool,
      title: propTypes.oneOfType([
        propTypes.string,
        propTypes.object,
      ]),
    })
  ),
  children: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
    propTypes.array,
  ]),
  className: propTypes.string,
  message: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
    propTypes.array,
  ]),
  open: propTypes.bool.isRequired,
  title: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
  ]),
}

export default Prompt
